import { render, staticRenderFns } from "./BrutoPlateRow.vue?vue&type=template&id=4e8a3a5a&scoped=true"
import script from "./BrutoPlateRow.vue?vue&type=script&lang=js"
export * from "./BrutoPlateRow.vue?vue&type=script&lang=js"
import style0 from "./BrutoPlateRow.vue?vue&type=style&index=0&id=4e8a3a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a3a5a",
  null
  
)

export default component.exports